<div class="label-header">
  <button mat-icon-button class="btn">
    <i style="font-size: 16px" class="ri-close-fill" matDialogClose></i>
  </button>
</div>

<ng-container *ngIf="variant$ | async as variant" [ngSwitch]="variant">
  <!-- ============================ CE variant (new label) ============================ -->
  <ng-container *ngSwitchCase="'ce'">
    <div class="label-title" data-cy="commercial-name">
      <h2>TELESPOT</h2>
    </div>
    <p data-cy="intended-purpose" class="intended-purpose">{{ 'core.intended_purpose' | translate }}</p>

    <div class="label-grid">
      <ng-container *ngTemplateOutlet="manufacturerBlock"></ng-container>

      <!-- g) UDI (HRI) -->
      <section class="label-section identifier-section">
        <div class="section-head">
          <img class="symbol" src="assets/media/labelling/udi.svg" alt="UDI" data-cy="udi-symbol" />
          <h3 data-cy="udi-label">{{ 'core.udi_label' | translate }}</h3>
        </div>
        <code data-cy="udi-hri" class="udi-hri">{{ udiHri }}</code>
      </section>

      <!-- e) IVD + CE (with Notified Body number) -->
      <section class="label-section regulatory" data-cy="regulatory-labels">
        <div class="symbols">
          <img src="assets/media/labelling/ivd.svg" data-cy="ivd-icon" alt="IVD" />
          <div class="ce-mark" data-cy="ce-icon">
            <img src="assets/media/labelling/ce.svg" alt="CE" />
            <span class="notified-body" data-cy="notified-body">{{ notifiedBody }}</span>
          </div>
        </div>
      </section>
    </div>

    <ng-container *ngTemplateOutlet="ifuFooter; context: { variant: 'ce' }"></ng-container>
  </ng-container>

  <!-- ============================ LEGACY variant (ADAPTASPOT SMART) ============================ -->
  <ng-container *ngSwitchCase="'legacy'">
    <div class="label-title" data-cy="commercial-name">
      <h2>ADAPTASPOT SMART</h2>
    </div>
    <p data-cy="intended-purpose" class="intended-purpose">{{ 'core.intended_purpose_legacy' | translate }}</p>

    <div class="label-grid">
      <ng-container *ngTemplateOutlet="manufacturerBlock"></ng-container>

      <!-- LOT (batch) symbol + version + date -->
      <section class="label-section identifier-section">
        <div class="section-head">
          <img class="symbol lot-symbol" src="assets/media/labelling/lot.svg" alt="LOT" data-cy="lot-symbol" />
          <div data-cy="lot-value" class="lot-value">
            v. <strong>{{ version }}</strong> · {{ manufactureDate | date }}
          </div>
        </div>
      </section>

      <!-- IVD + CE (without Notified Body number) -->
      <section class="label-section regulatory" data-cy="regulatory-labels">
        <div class="symbols">
          <img src="assets/media/labelling/ivd.svg" data-cy="ivd-icon" alt="IVD" />
          <div class="ce-mark" data-cy="ce-icon">
            <img src="assets/media/labelling/ce.svg" alt="CE" />
          </div>
        </div>
      </section>
    </div>

    <ng-container *ngTemplateOutlet="ifuFooter; context: { variant: 'legacy' }"></ng-container>
  </ng-container>

  <!-- ============================ RUO variant (legacy style, research use only) ============================ -->
  <ng-container *ngSwitchCase="'ruo'">
    <div class="label-title" data-cy="commercial-name">
      <h2>TELESPOT</h2>
    </div>

    <div class="label-grid">
      <ng-container *ngTemplateOutlet="manufacturerBlock"></ng-container>

      <!-- Version + date (no UDI, no regulatory marks) -->
      <section class="label-section">
        <div class="section-head">
          <h3 data-cy="version-label">{{ 'core.version' | translate }}</h3>
        </div>
        <div data-cy="version-value">v. <strong>{{ version }}</strong></div>
        <div data-cy="manufacture-date">
          {{ 'core.manufacture_date' | translate }}: <strong>{{ manufactureDate | date }}</strong>
        </div>
      </section>
    </div>

    <!-- RUO label always shown -->
    <div class="ruo-label" data-cy="ruo-label">{{ 'core.ruo_label' | translate }}</div>
  </ng-container>

  <!-- ============================ Basic variant (no organization / no labeling) ============================ -->
  <ng-container *ngSwitchDefault>
    <div class="label-title" data-cy="commercial-name">
      <h2>TELESPOT</h2>
    </div>

    <div class="label-grid">
      <ng-container *ngTemplateOutlet="manufacturerBlock"></ng-container>

      <!-- Version + date only; no regulatory marks, UDI or eIFU -->
      <section class="label-section">
        <div class="section-head">
          <h3 data-cy="version-label">{{ 'core.version' | translate }}</h3>
        </div>
        <div data-cy="version-value">v. <strong>{{ version }}</strong></div>
        <div data-cy="manufacture-date">
          {{ 'core.manufacture_date' | translate }}: <strong>{{ manufactureDate | date }}</strong>
        </div>
      </section>
    </div>
  </ng-container>
</ng-container>

<!-- ============================ Shared blocks ============================ -->
<ng-template #manufacturerBlock>
  <section class="label-section">
    <div class="section-head">
      <img data-cy="manufactured-image" class="symbol" src="assets/media/labelling/fill_fab.png" alt="manufacturer" />
      <h3 data-cy="manufactured-label">{{ 'core.manufactured' | translate }}</h3>
    </div>
    <a data-cy="manufactured-url" href="https://spotlab.org" target="_blank">SPOTLAB, S.L.</a>
    <div data-cy="manufactured-nif">NIF: B87755146</div>
    <div data-cy="manufactured-address">Paseo de Juan XXIII, 36B</div>
    <div data-cy="manufactured-post-code">28045 Madrid</div>
    <div data-cy="manufactured-email">
      E-mail: <a href="mailto:support@spotlab.org">support&#64;spotlab.org</a>
    </div>
  </section>
</ng-template>

<ng-template #ifuFooter let-variant="variant">
  <div class="symbols-footer">
    <div class="symbol-group" data-cy="default-labels">
      <div class="ifu-heading">
        <img src="assets/media/labelling/instructions.svg" alt="instructions" />
        <span>{{ 'core.instructions_for_use' | translate }}</span>
      </div>
      <div class="ifu-controls">
        <!-- CE offers all languages; LEGACY IFU is English only. -->
        <select *ngIf="variant === 'ce'" data-cy="ifu-lang" (change)="selectedLang = $any($event.target).value">
          <option *ngFor="let l of languages" [value]="l.value" [selected]="l.value === selectedLang">
            {{ l.label | translate }}
          </option>
        </select>
        <button type="button" data-cy="ifu-download"
          (click)="variant === 'ce' ? downloadIfu('ce', selectedLang) : downloadIfu('legacy', 'en')"
          [disabled]="loadingIfu">
          {{ 'button.download' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
